import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { id: 'search', label: 'ค้นหา', icon: '🔍', href: '/' },
  { id: 'hints', label: 'เลขเด็ด', icon: '✨', sectionId: 'hints' },
  { id: 'tarot', label: 'ไพ่ยิปซี', icon: '🔮', href: '/tarot' },
  { id: 'stats', label: 'สถิติ', icon: '📊', sectionId: 'stats' },
  { id: 'articles', label: 'บทความ', icon: '📰', sectionId: 'articles' },
];

export default function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleNav = (item) => {
    if (item.href) {
      if (location.pathname !== item.href) {
        navigate(item.href);
        return;
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    if (item.sectionId && location.pathname !== '/') {
      navigate(`/#${item.sectionId}`);
      return;
    }
    scrollToSection(item.sectionId || item.id);
  };

  const isActive = (item) => {
    if (item.href) return location.pathname === item.href;
    return false;
  };

  return (
    <nav className="mobile-bottom-nav" aria-label="เมนูหลัก">
      {NAV_ITEMS.map((item) => (
        <button
          key={item.id}
          type="button"
          className={`mobile-bottom-nav__item${isActive(item) ? ' mobile-bottom-nav__item--active' : ''}`}
          onClick={() => handleNav(item)}
          aria-label={item.label}
          aria-current={isActive(item) ? 'page' : undefined}
        >
          <span className="mobile-bottom-nav__icon" aria-hidden="true">{item.icon}</span>
          <span className="mobile-bottom-nav__label">{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
